import { NgModule } from '@angular/core';
import { SpartacusCartFeatureModule } from '@app/spartacus/features/cart/cart-feature.module';
import { SpartacusConsentFeatureModule } from '@app/spartacus/features/consent/consent-feature.module';
import { SpartacusOrderFeatureModule } from '@app/spartacus/features/order/order-feature.module';
import { WishListModule } from '@spartacus/cart/wish-list';
import { AuthModule, ExternalRoutesModule, ProductModule, ProductOccModule } from '@spartacus/core';
import {
  BannerCarouselModule,
  BannerModule,
  BreadcrumbModule,
  CategoryNavigationModule,
  CmsParagraphModule,
  FooterNavigationModule,
  HamburgerMenuModule,
  HomePageEventModule,
  LinkModule,
  LoginRouteModule,
  LogoutModule,
  MyCouponsModule,
  MyInterestsModule,
  NavigationEventModule,
  NavigationModule,
  NotificationPreferenceModule,
  PaymentMethodsModule,
  ProductDetailsPageModule,
  ProductFacetNavigationModule,
  ProductImagesModule,
  ProductIntroModule,
  ProductListingPageModule,
  ProductListModule,
  ProductPageEventModule,
  ProductReferencesModule,
  ProductSummaryModule,
  ProductTabsModule,
  SearchBoxModule,
  SiteContextSelectorModule,
  StockNotificationModule,
  TabParagraphContainerModule
} from '@spartacus/storefront';
import { AddressBookModule } from '@spartacus/user/profile/components';
import { AsmFeatureModule } from './features/asm/asm-feature.module';
import { CdcFeatureModule } from './features/cdc/cdc-feature.module';
import { CdsFeatureModule } from './features/cds/cds-feature.module';
import { OrganizationAdministrationFeatureModule } from './features/organization/organization-administration-feature.module';
import { OrganizationOrderApprovalFeatureModule } from './features/organization/organization-order-approval-feature.module';
import { ProductConfiguratorFeatureModule } from './features/product-configurator/product-configurator-feature.module';
import { ProductBulkPricingFeatureModule } from './features/product/product-bulk-pricing-feature.module';
import { ProductVariantsFeatureModule } from './features/product/product-variants-feature.module';
import { QualtricsFeatureModule } from './features/qualtrics/qualtrics-feature.module';
import { SmartEditFeatureModule } from './features/smartedit/smart-edit-feature.module';
import { StoreFinderFeatureModule } from './features/storefinder/store-finder-feature.module';
import { PersonalizationFeatureModule } from './features/tracking/personalization-feature.module';
import { TagManagementFeatureModule } from './features/tracking/tag-management-feature.module';
import { SpartacusUserFeatureModule } from './features/user/user-feature.module';
import { SpartacusCheckoutFeatureModule } from './features/checkout/checkout-feature.module';

const spartacusFeatureModules = [
  SpartacusOrderFeatureModule,
  SpartacusCheckoutFeatureModule,
  SpartacusConsentFeatureModule,
  SpartacusUserFeatureModule,
  SpartacusCartFeatureModule
];

@NgModule({
  imports: [
    // feature modules
    ...spartacusFeatureModules,
    // Auth Core
    AuthModule.forRoot(),
    LogoutModule,
    LoginRouteModule,
    // Basic Cms Components
    HamburgerMenuModule,
    SiteContextSelectorModule,
    LinkModule,
    BannerModule,
    CmsParagraphModule,
    TabParagraphContainerModule,
    BannerCarouselModule,
    CategoryNavigationModule,
    NavigationModule,
    FooterNavigationModule,
    BreadcrumbModule,
    // User UI,
    AddressBookModule,
    PaymentMethodsModule,
    NotificationPreferenceModule,
    MyInterestsModule,
    StockNotificationModule,
    MyCouponsModule,
    // DpRelatedPartProduct Core,
    ProductModule.forRoot(),
    ProductOccModule,
    // DpRelatedPartProduct UI,
    ProductDetailsPageModule,
    ProductListingPageModule,
    ProductListModule,
    SearchBoxModule,
    ProductFacetNavigationModule,
    ProductTabsModule,
    ProductReferencesModule,
    ProductImagesModule,
    ProductSummaryModule,
    ProductIntroModule,
    WishListModule,
    // Page Events,
    NavigationEventModule,
    HomePageEventModule,
    ProductPageEventModule,
    // External routes,
    ExternalRoutesModule.forRoot(),
    TagManagementFeatureModule,
    PersonalizationFeatureModule,
    StoreFinderFeatureModule,
    SmartEditFeatureModule,
    QualtricsFeatureModule,
    ProductConfiguratorFeatureModule,
    ProductBulkPricingFeatureModule,
    ProductVariantsFeatureModule,
    OrganizationAdministrationFeatureModule,
    OrganizationOrderApprovalFeatureModule,
    CdsFeatureModule,
    CdcFeatureModule,
    AsmFeatureModule
  ]
})
export class SpartacusFeaturesModule {}
